// One deployment, three public entrances: the main EduTech site (buma.academy), the kids/family site
// (buma.academy/kids) and the staff login (buma.academy/staff-login). The hosting serves TLS for ONE hostname only,
// so stem.buma.academy / login.buma.academy are DNS-level URL forwards to those paths (never CNAMEs).
// Landing on /kids (or `?as-host=kids|main|off`) stores a session-wide "kids mode" so every page shows the family chrome.
const split = (v, d) => (v || d).split(",").map((h) => h.trim()).filter(Boolean);
export const STAFF_HOSTS = split(process.env.REACT_APP_STAFF_HOSTS, "login.,bumalogin.");
export const KIDS_HOSTS = split(process.env.REACT_APP_KIDS_HOSTS, "stem.,kids.");
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || "https://buma.academy";
export const KIDS_PATH = "/kids";
export const KIDS_URL = process.env.REACT_APP_KIDS_URL || `${MAIN_URL}${KIDS_PATH}`;
export const STAFF_PATH = "/staff-login";
export const STAFF_URL = process.env.REACT_APP_STAFF_URL || `${MAIN_URL}${STAFF_PATH}`;

const KEY = "buma:host-override";
try {
  const url = new URL(window.location.href);
  const q = url.searchParams.get("as-host");
  if (q === "kids" || q === "main") sessionStorage.setItem(KEY, q);
  if (q === "off") sessionStorage.removeItem(KEY);
  if (url.pathname === KIDS_PATH) sessionStorage.setItem(KEY, "kids");
  if (q) { url.searchParams.delete("as-host"); window.history.replaceState(null, "", url.pathname + url.search + url.hash); }
} catch { /* no storage */ }
const override = () => { try { return sessionStorage.getItem(KEY); } catch { return null; } };
const host = () => window.location.hostname;

export const isStaffHost = () => STAFF_HOSTS.some((h) => host() === h || host().startsWith(h));
export const isKidsHost = () => override() === "kids" || (override() !== "main" && KIDS_HOSTS.some((h) => host() === h || host().startsWith(h)));
// the main host is any public host that is neither kids nor staff (includes previews / localhost)
export const isMainHost = () => !isKidsHost() && !isStaffHost();
// Cross-site links: absolute on the real domains (works from login.*), same-origin in previews.
const PROD_SUFFIXES = ["buma.academy", "ahdaf.me"];
const base = () => (PROD_SUFFIXES.some((s) => host().endsWith(s)) ? MAIN_URL : "");
const withHost = (path, mode) => `${path}${path.includes("?") ? "&" : "?"}as-host=${mode}`;
export const kidsHref = (path = "/") => (path === "/" ? (base() ? KIDS_URL : KIDS_PATH) : `${base()}${withHost(path, "kids")}`);
export const mainHref = (path = "/") => `${base()}${withHost(path, "main")}`;
